import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { PrimaryButton } from '@bingads-webui-react/fabric-control';

import { ActionType, ActionTextKey } from '../constants';

export const MonitoringCardButton = ({
  actionType, i18n, onClick, ButtonComponent,
}) => (
  <ButtonComponent
    className={`monitoring-card-button-${actionType}`}
    onClick={onClick}
  >
    {i18n.getString(ActionTextKey[actionType])}
  </ButtonComponent>
);

MonitoringCardButton.propTypes = {
  actionType: PropTypes.oneOf(_.values(ActionType)).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  ButtonComponent: PropTypes.func,
};

MonitoringCardButton.defaultProps = {
  ButtonComponent: PrimaryButton,
};
